import { detectBrandNameFromUrl } from "@/helpers/branding-helpers";
import { BrandName, BRAND_NAME_STORAGE_KEY } from "@/types/branding";
import * as React from "react";

export const useBrandName = (): BrandName => {
  const [brandName, setBrandName] = React.useState<BrandName>(() => {
    let res = detectBrandNameFromUrl();
    localStorage.setItem(BRAND_NAME_STORAGE_KEY, res);
    return res;
  });

  React.useEffect(() => {
    const handleDomainChange = () => {
      const newBrandName = detectBrandNameFromUrl();
      if (newBrandName !== brandName) {
        setBrandName(newBrandName);
        localStorage.setItem(BRAND_NAME_STORAGE_KEY, newBrandName);
      }
    };
    window.addEventListener("popstate", handleDomainChange);
    window.addEventListener("hashchange", handleDomainChange);

    return () => {
      window.removeEventListener("popstate", handleDomainChange);
      window.removeEventListener("hashchange", handleDomainChange);
    };
  }, [brandName]);

  return brandName;
};
